import { render, staticRenderFns } from "./PackagingDetail.template.vue?vue&type=template&id=8968783c&scoped=true&"
var script = {}
import style0 from "./PackagingDetail.template.vue?vue&type=style&index=0&id=8968783c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8968783c",
  null
  
)

export default component.exports